import { BasePage } from '../base.page';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from 'src/app/services/auth.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { Platform, LoadingController, ToastController } from '@ionic/angular';

@Component({
  selector: 'shc-choose-language',
  templateUrl: './choose-language.page.html',
  styleUrls: ['./choose-language.page.scss'],
})
export class ChooseLanguagePage extends BasePage implements OnInit {
  form: UntypedFormGroup;
  languages = [
    {
      img: '../../../../assets/images/auth/us-flag.png',
      title: 'English',
      value: 'en',
    },
    {
      img: '../../../../assets/images/auth/nl-flag.svg',
      title: 'Nederlands',
      value: 'nl',
    },
    // {
    //   img: '../../../../assets/images/auth/us-flag.png',
    //   title: 'Spanish',
    //   value: 'es'
    // },
    // {
    //   img: '../../../../assets/images/auth/us-flag.png',
    //   title: 'French',
    //   value: 'fr'
    // },
    // {
    //   img: '../../../../assets/images/auth/us-flag.png',
    //   title: 'Italian',
    //   value: 'it'
    // },
    // {
    //   img: '../../../../assets/images/auth/us-flag.png',
    //   title: 'German',
    //   value: 'nds'
    // }
  ];

  constructor(
    protected platform: Platform,
    protected userService: UserService,
    protected authService: AuthService,
    protected translate: TranslateService,
    private errorService: ErrorHandlerService,
    protected loadingCtrl: LoadingController,
    toastController: ToastController,
    private router: Router,
    private location: Location,
  ) {
    super(
      platform,
      userService,
      authService,
      translate,
      loadingCtrl,
      toastController,
    );

    this.form = new UntypedFormGroup({
      locale: new UntypedFormControl(null),
    });
  }

  ngOnInit() {
    this.form.patchValue({
      locale: this.user?.locale,
    });
  }

  ionViewWillEnter() {}

  chooseLanguage() {
    this.showLoader();
    this.userService.updateLanguage(this.form.value).subscribe(
      (res) => {
        this.user.locale = res.locale;
        this.translate.setDefaultLang(res.locale);
        this.translate.use(res.locale);
        setTimeout(() => {
          this.hideLoader();
          this.router.navigate(['tabs'], { replaceUrl: true });
        }, 1000);
      },
      (error) => {
        this.errorService.handle(error);
      },
    );
  }

  back() {
    this.location.back();
  }
}
